import axios, { AxiosResponse } from 'axios';
import { FetchHashLoungesType } from '../redux/lounges/slice';
import { Lounge } from '../redux/lounges/types';
import { GET_BASE_URL } from '../constants/apiEndpoints';
import { LOUNGE_GET_TIMEOUT_MS } from '../utils/loungeRequest';
export const getHashLoungesApi = async ({
  sortType,
  LoungeId,
  currentPage,
  tagValue,
  shortByTime,
}: FetchHashLoungesType) => {
  const normalizedTagValue = `${tagValue ?? ''}`.replace(/^#/, '').trim();
  if (!normalizedTagValue) {
    return [];
  }

  const responseBody = (response: AxiosResponse) => response.data;
  localStorage.setItem('pagename', normalizedTagValue);

  const user_id = localStorage.getItem('user_id');
  const sortByTime = shortByTime === 'true' ? `&sortordefault=ww` : '';
  const apiEndpoint =
    GET_BASE_URL +
    `/api/v1/hash?user_id=${user_id}&hash=${encodeURIComponent(normalizedTagValue)}` +
    sortByTime;

  const { data } = await axios
    .get<Lounge[]>(`${apiEndpoint}`, {
      timeout: LOUNGE_GET_TIMEOUT_MS,
    })
    .then(responseBody);
  return data;
};
